export const PromotionHubClickEventLabels = {
    promotionsTab: 'promotions_tab',
    inProgressTab: 'in_progress_tab',
    bonusTab: 'bonus_tab',
    historyTab: 'history_tab',
    // promotion offer card
    promotionsDetailsExpand: 'promotions_details_expand',
    promotionsDetailsCollapse: 'promotions_details_collapse',
    promotionsTerms: 'promotions_T&C',
    promotionsOptIn: 'promotions_opt_in',
    promotionsOptInFirstClick: 'promotions_opt_in_1st_click',
    promotionsOptOut: 'promotions_opt_out',
    promotionsPlayNow: 'promotions_play_now',
    // promotion in-progress card
    inProgressDetailsExpand: 'in_progress_details_expand',
    inProgressDetailsCollapse: 'in_progress_details_collapse',
    inProgressWagering: 'in_progress_wagering',
    inProgressDeposit: 'in_progress_deposit',
    // bonus card
    bonusPlayNowButton: 'bonus_action_button_click',
    // history card
    historyDetailsExpand: 'history_details_expand',
    historyDetailsCollapse: 'history_details_collapse',
    historyViewOffers: 'history_view_offers',
    // Eligible for campaign pop-up
    popUpInterested: 'pop_up_interested',
    popUpNotInterested: 'pop_up_not_interested',
} as const;
export type PromotionHubClickEventLabels = typeof PromotionHubClickEventLabels[keyof typeof PromotionHubClickEventLabels];
